export const HOME = "/";
export const ROADMAP = "/roadmap";
export const GALLERY = "/gallery";
export const SUB = "/subscribe";
export const MAP = "/radmap";